export type DesignerInfoItemType = 'email' | 'phone' | 'profile';

export type DesignerInfoItem = {
  label: string;
  type: DesignerInfoItemType;
};

export const DESIGNER_PROFILE_INFO_ITEM: DesignerInfoItem = {
  label: '视觉设计师-刘嘉豪',
  type: 'profile',
};

export const DESIGNER_CONTACT_INFO_ITEMS: DesignerInfoItem[] = [
  {
    label: 'TEL：13537642896',
    type: 'phone',
  },
  {
    label: 'EMAIL：1013697746@qq.com',
    type: 'email',
  },
];

export const DESIGNER_INFO_ITEMS: DesignerInfoItem[] = [
  DESIGNER_PROFILE_INFO_ITEM,
  ...DESIGNER_CONTACT_INFO_ITEMS,
];
